import { useTranslation } from 'next-i18next';
import React from 'react';
import { FdrMapButtonForDesktop } from './fdr-map-button-desktop';

interface IFdrMapAccessButtonProps {
  onOpen(): void;
}

const FdrMapAccessButton: React.FC<IFdrMapAccessButtonProps> = props => {
  const { onOpen } = props;
  const [t] = useTranslation('common');

  return (
    <FdrMapButtonForDesktop onClick={onOpen}>
      {t('mapButton')}
    </FdrMapButtonForDesktop>
  );
};

export default FdrMapAccessButton;
